/* Base translations · Misstatements page — moved unchanged out of lib/i18n.js (STEP 2 · B2).
   Top-level keys owned by this file (no other base file and not i18n.js define them): misstatementsPage. */
export const I18N_BASE_MISSTATEMENTS = {
  en: {
    misstatementsPage: {
      title: "Misstatements Summary",
      subtitle: "Uncorrected and corrected misstatements — evaluation vs 105(a).",
      stopGapNote: "",
      summary: "Summary",
      unresolved: "Unresolved",
      empty: "No misstatements recorded yet.",
      cols: {
        fsHead: "FS head",
        description: "Description",
        amount: "Amount",
        type: "Type",
        status: "Status",
        source: "Source",
        when: "When",
        by: "By",
      },
    },
  },
  ar: {
    misstatementsPage: {
      title: "ملخص التحريفات",
      subtitle: "التحريفات غير المصحّحة والمصحّحة — التقييم مقابل 105(a).",
      stopGapNote: "",
      summary: "الملخص",
      unresolved: "غير محلول",
      empty: "لا توجد تحريفات مسجلة بعد.",
      cols: {
        fsHead: "بند القوائم",
        description: "الوصف",
        amount: "المبلغ",
        type: "النوع",
        status: "الحالة",
        source: "المصدر",
        when: "التاريخ",
        by: "بواسطة",
      },
    },
  },
};

export default I18N_BASE_MISSTATEMENTS;
